import { HttpBadRequest } from '@httpx/exception'
import type { GetStaticProps, InferGetStaticPropsType } from 'next'
import { HomePage } from '@/features/home/pages'

type Props = {
  /** Add HomeRoute props here */
}

export default function MainRoute(_props: InferGetStaticPropsType<typeof getStaticProps>) {
  return <HomePage />
}

export const getStaticProps: GetStaticProps<Props> = async context => {
  const { locale } = context
  if (locale === undefined) {
    throw new HttpBadRequest('locale is missing')
  }
  return {
    props: {},
  }
}
